module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 102-8701ef4f1576ef553c6703e2d53ffd2c.png";